import { Outlet } from "react-router-dom";

export default function KeyIn() {
  return <Outlet />;
}
